import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { RequestTypes } from '../requestTypes'
import { checklistsKeys } from '../checklistsKeys'
import {
  IParticipantListItem,
  ParticipantListItem,
} from '@core/entities/participant/ParticipantListItem'

const participantsTransform = (data: IParticipantListItem[]) =>
  data.map(ParticipantListItem.new)

export const useGetChecklistRecentParticipants = (
  payload: RequestTypes['getChecklistParticipants'],
  options?: UseQueryOptions<ParticipantListItem[], string>,
) => {
  return useQuery({
    cacheTime: 1000 * 60 * 60 * 24 * 31 * 6, // 6 months
    select: participantsTransform,
    ...checklistsKeys.getRecentParticipants(payload),
    ...options,
  })
}
